export function generatePasswords(amount = 1) {
  const passwords = [];

  for (let i = 0; i < amount; i++) {
    passwords.push(generatePassword());
  }

  return passwords;
}

/**
 * Genera una contraseña de 8 caracteres con letras (al menos una mayúscula), números y símbolos aleatorios en posiciones aleatorias.
 */
const generatePassword = () => {
  const symbols = "!@#$%^&*";
  const letters = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const allChars = symbols + letters + numbers + letters.toUpperCase();

  const password = [];

  password.push(getRandomChar(letters.toUpperCase()));
  password.push(getRandomChar(letters));
  password.push(getRandomChar(numbers));
  password.push(getRandomChar(symbols));

  for (let i = password.length; i < 8; i++) {
    password.push(getRandomChar(allChars));
  }

  for (let i = password.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [password[i], password[j]] = [password[j], password[i]];
  }

  return password.join("");
};

const getRandomChar = (str) => str[Math.floor(Math.random() * str.length)];
